import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { resetPasswordSchema, resetPasswordInput } from '../features/auth/authSchema';
import { useResetPasswordMutation } from '../api/authAPI';
import { useSearchParams, useNavigate } from 'react-router-dom';
import FormInput from './FormInput';
import Button from './UI/Button';
import { CardSimple } from './UI/Card';
import { useState } from 'react';

const ResetPasswordForm = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';
    const [message, setMessage] = useState("")
    const [error, setError] = useState("")
    const navigate = useNavigate()

    const [resetPassword, { isLoading }] = useResetPasswordMutation();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<resetPasswordInput>({
        resolver: zodResolver(resetPasswordSchema),
    });

    const onSubmit = async (data: resetPasswordInput) => {
        try {
            await resetPassword({
                token,
                password: data.password,
                confirmPassword: data.confirmPassword,
            }).unwrap();
            setMessage("הסיסמה אופסה בהצלחה! תועבר/י לדף ההתחברות בעוד מספר שניות.")
            setError("")
            setTimeout(() => { setMessage(""); navigate('/login') },3000)
        }
        catch (err: any) {
            setMessage("")
            setError(err?.data?.message || "עדכון הסיסמא נכשל")
        }
    }
    return (
        <div
            className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-100 via-muted to-blue-light p-4"
            dir="rtl"
        >
            <CardSimple className="w-full max-w-lg mx-auto">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">

                    <h2 className="text-3xl font-bold text-center text-primary">איפוס סיסמא</h2>

                    <FormInput
                        label="סיסמה חדשה"
                        type="password"
                        placeholder="הכנס סיסמה חדשה"
                        register={register('password')}
                        error={errors.password?.message}
                    />

                    <FormInput
                        label="אימות סיסמה"
                        type="password"
                        placeholder="הכנס אימות סיסמה"
                        register={register('confirmPassword')}
                        error={errors.confirmPassword?.message}
                    />

                    <Button type="submit" isLoading={isLoading} fullWidth>
                        איפוס סיסמא
                    </Button>

                    {message && <p className="text-success text-center text-sm font-medium">{message}</p>}
                    {error && <p className="text-danger text-center text-sm font-medium">{error}</p>}
                </form>
            </CardSimple>
        </div>
    );
};

export default ResetPasswordForm;
